/**
 * Created by zhangrp on 2018/4/3.
 */

import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbBizFormListForSelect from './BizFormListForSelect';
Vue.regist(SwbBizFormListForSelect);

// 选择经营业态
export function openBizFormSelectionDlg(dlgConfig, callback) {
    let checkedIds = dlgConfig['checkedIds'] || []; // 回显数据
    let isShowSelection = dlgConfig['isShowSelection']; // 是否多选
    let bizAreaName = dlgConfig['bizAreaName'] || null; // 是否多选
    //
    let theDlg = Vue.$showDialog({
        title: "经营业态 - 选择",
        width: 1200,
        height: 800,
        template: '<swb-retailer-bizForm-list-for-select :bizAreaName="bizAreaName" :checkedIds="checkedIds" :isShowSelection="isShowSelection" ref="swb_retailer_bizForm_list_for_select"></swb-retailer-bizForm-list-for-select>',
        data: {
            checkedIds: checkedIds,
            isShowSelection: isShowSelection,
            bizAreaName: bizAreaName,
        },
        okClicked: function () {
            let result = this.$refs.swb_retailer_bizForm_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/bizForm/selectDlg.js
// module id = 193
// module chunks = 0